import React from 'react';
import CurrencyInput from 'react-currency-input-field';

function Listinput({
  classes,
  errors,
  type = 'text',
  placeholder,
  pnc,
  keyName,
  onChange,
  onFocus = null,
  onBlur = null
}) {
  return (
    <div
      className={`${classes} u--margin-bottom-0 u--padding-left-0 u--padding-right-0 form__field form__field--required ${
        errors[keyName + pnc.id] ? 'form__field--error' : ''
      }`}
    >
      {keyName === 'numGallons' ? (
        <CurrencyInput
          className="pnc__input form__input"
          placeholder={placeholder}
          name={keyName}
          value={pnc[keyName]}
          onValueChange={(value) => onChange(pnc.id, keyName, value)}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      ) : (
        <input
          className="pnc__input form__input"
          type={type}
          placeholder={placeholder}
          value={pnc[keyName]}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      )}
    </div>
  );
}

export default Listinput;
